module.exports = __webpack_public_path__ + "static/playfairdisplay-regular-d1c67ffdfcf54ffbe876a8fb3f7172de.woff";